import { FC } from 'react';
import { useAppDispatch, useAppSelector } from '@core/hooks/redux-hooks';
import Button from '@app/shared/components/button/Button';
import { ButtonAppearance, ButtonSize } from '@app/shared/components/button/button-enums';
import SvgSync from '@app/shared/icons/Sync';
import * as projectActions from '@core/store/project-slice';

export const RefreshCalculationsAction: FC = (): JSX.Element => {
  const projectDraft = useAppSelector((state) => state.project.projectDraft);
  const dispatch = useAppDispatch();

  const handleRefreshCalculations = () => {
    if (projectDraft) {
      dispatch(projectActions.updateProjectDraft({ project: projectDraft, forceRefresh: true }));
    }
  };

  return (
    <Button
      data-testid="refresh-calculations"
      onClick={() => handleRefreshCalculations()}
      appearance={ButtonAppearance.DEFAULT_SECONDARY}
      size={ButtonSize.SMALL}
      startIcon={<SvgSync />}
      aria-label="Refresh calculations"
      style={{ minWidth: 'unset' }}
    />
  );
};
